//通过map 方式获取所有树形结构数据
export function listConvertTreeByRoots(
  list,
  idName = "id",
  parentIdName = "parentId",
  root = false
) {
  let tree = [];
  let temp = listConvertMapTree(list, idName, parentIdName, false);
  for (let key in temp) {
    let tempDara = listConvertTree(list, key, idName, parentIdName);
    temp[key].children = tempDara.children;
    tree.push(temp[key]);
  }
  return tree;
}
//通过 map 和 根节点获取所有底下树形数据
export function listConvertMapTree(
  list,
  idName = "id",
  parentIdName = "parentId",
  root = false
) {
  let temp = {};
  let tree = {};
  for (let i in list) {
    temp[list[i][idName]] = list[i];
  }
  for (let i in temp) {
    if (temp[i][parentIdName] && temp[temp[i][parentIdName]]) {
      if (root === true) continue;
      let s = temp[i][parentIdName];
      let s1 = temp[temp[i][parentIdName]];
      if (!temp[temp[i][parentIdName]].children) {
        temp[temp[i][parentIdName]].children = new Object();
      }
      temp[temp[i][parentIdName]].children[temp[i][idName]] = temp[i];
    } else {
      tree[temp[i][idName]] = temp[i];
    }
  }
  return tree;
}

//通过节点获取所有底下树形数据
export function listConvertTree(
  list,
  rootId = 0,
  idName = "id",
  parentIdName = "parentId"
) {
  let root = null;
  if (list && list.length) {
    root = { children: [] };
    root[idName] = rootId;
    root[parentIdName] = null;
    const group = {};
    for (let index = 0; index < list.length; index += 1) {
      if (
        list[index][parentIdName] !== null &&
        list[index][parentIdName] !== undefined
      ) {
        if (!group[list[index][parentIdName]]) {
          group[list[index][parentIdName]] = [];
        }
        group[list[index][parentIdName]].push(list[index]);
      }
    }
    const queue = [];
    queue.push(root);
    while (queue.length) {
      const node = queue.shift();
      node.children =
        group[node[idName]] && group[node[idName]].length
          ? group[node[idName]]
          : null;
      if (node.children) {
        queue.push(...node.children);
      }
    }
  }
  return root;
}

export function treeConvertList(
  root,
  idName = "id",
  parentIdName = "parentId"
) {
  const list = [];
  if (root) {
    const Root = JSON.parse(JSON.stringify(root));
    const queue = [];
    queue.push(Root);
    while (queue.length) {
      const node = queue.shift();
      if (node.children && node.children.length) {
        queue.push(...node.children);
      }
      delete node.children;
      if (node[parentIdName] !== null && node[parentIdName] !== undefined) {
        list.push(node);
      }
    }
  }
  return list;
}
